import apiClient from '@/utils/api';

const CITY_KEY = 'zenstudios_user_city';

export const getStoredCity = () => {
  try {
    return localStorage.getItem(CITY_KEY) || '';
  } catch {
    return '';
  }
};

export const setStoredCity = (city) => {
  try {
    if (city) localStorage.setItem(CITY_KEY, city);
  } catch {
    /* ignore storage errors */
  }
};

// Silent IP-based detection via Cloudflare edge headers. Returns a city string or ''.
export const detectCity = async () => {
  try {
    const { data } = await apiClient.get('/geo/detect');
    return data?.city || '';
  } catch {
    return '';
  }
};

// Resolve the city to use on first load.
// Priority: explicit URL param > user's stored choice > silent IP detection.
export const resolveInitialCity = async (urlCity) => {
  if (urlCity) return urlCity;
  const stored = getStoredCity();
  if (stored) return stored;
  const detected = await detectCity();
  if (detected) {
    setStoredCity(detected);
    return detected;
  }
  return '';
};
